import { MdCall, MdLocationOn, MdMail, MdBusiness } from "react-icons/md";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import PageHero from "./PageHero";
import CallToAction from "./callToAction";
import heroImage from "../assets/construction2.png";
import { snjContact } from "./Footer";

const contactCards = [
  {
    label: "E-mail",
    value: snjContact.email,
    href: `mailto:${snjContact.email}`,
    Icon: MdMail,
  },
  {
    label: "Mobile One",
    value: snjContact.phone,
    href: `tel:${snjContact.phone.replace(/\s/g, "")}`,
    Icon: MdCall,
  },
  {
    label: "Mobile Two",
    value: snjContact.phoneAlt,
    href: `tel:${snjContact.phoneAlt.replace(/\s/g, "")}`,
    Icon: MdCall,
  },
  {
    label: "Head Office",
    value: snjContact.location,
    href: "https://www.google.com/maps/search/?api=1&query=Ubungo%20NHC%20Dar%20es%20Salaam%20Tanzania",
    Icon: MdLocationOn,
  },
];

export default function ContactUsContent() {
  return (
    <>
      <PageHero
        eyebrow="Contact"
        title="Reach SNJ Tanzania Limited head office."
        text="Contact the Dar es Salaam team for building works, civil works, water projects, renovation, project supervision, maintenance, and design support."
        image={heroImage}
      />

      <section className="tgm-section tgm-contact-page">
        <div className="container">
          <div className="tgm-contact-layout">
            <MotionGroup className="tgm-contact-intro" stagger={0.08}>
              <MotionReveal
                as="p"
                className="tgm-section-kicker"
                variant="soft"
              >
                SNJ Tanzania Limited
              </MotionReveal>
              <MotionText
                as="h2"
                text="Professional construction support from Dar es Salaam."
              />
              <MotionReveal as="p" variant="soft">
                Send your project scope, service inquiry, or consultation request
                and the team will follow up with practical construction support.
              </MotionReveal>
              <MotionReveal className="tgm-contact-office-card" variant="card">
                <MdBusiness />
                <div>
                  <span>{snjContact.office}</span>
                  <strong>{snjContact.postal}</strong>
                  <p>{snjContact.location}</p>
                </div>
              </MotionReveal>
            </MotionGroup>

            <MotionGroup className="tgm-contact-card-grid" stagger={0.08}>
              {contactCards.map((card) => (
                <MotionItem
                  as="a"
                  variant="card"
                  className="tgm-contact-card"
                  href={card.href}
                  key={card.label}
                  target={card.label === "Head Office" ? "_blank" : undefined}
                  rel={card.label === "Head Office" ? "noreferrer" : undefined}
                  whileHover={{ y: -6 }}
                  whileTap={{ scale: 0.985 }}
                >
                  <card.Icon />
                  <div>
                    <span>{card.label}</span>
                    <strong>{card.value}</strong>
                  </div>
                </MotionItem>
              ))}
            </MotionGroup>
          </div>
        </div>
      </section>

      <CallToAction />
    </>
  );
}
